<header class="linq-app-bar mdc-top-app-bar" [class.flyout-opened]="flyoutOpen$ | async">
	<mat-toolbar>
		<button *ngIf="elementActive(layoutElements.NAV)" (click)="openSideNav()" mat-icon-button aria-label="Menu icon">
			<mat-icon>menu</mat-icon>
		</button>
		<span class="linq-app-bar__title">
			<div class="logo"></div>
			<span class="divider"></span>
			<span *ngIf="elementActive(layoutElements.NAME)" class="product-name">Bookkeeping</span>
			<ng-container *ngIf="elementActive(layoutElements.UNIT)">
				<span class="divider"></span>
				<span class="unit-name">Unit {{unitId}} {{unitUnitName}}</span>
			</ng-container>
		</span>
		<span class="spacer"></span>
		<button *ngIf="elementActive(layoutElements.FEE_MANAGEMENT)" mat-icon-button aria-label="Fee Management" matTooltip="Go to Fee Management"
			(click)="onFeeManagementButtonClick()">
			<mat-icon>payment</mat-icon>
		</button>
		<button *ngIf="elementActive(layoutElements.HELP)" mat-icon-button aria-label="Help" class="helpLinkImage">
			<mat-icon>help_outline</mat-icon>
		</button>
		<button *ngIf="elementActive(layoutElements.BUILDINFO)" mat-icon-button aria-label="Application Build Information" restoreFocus="true"
			[matMenuTriggerFor]="buildInfoMenu" matTooltip="Application Build Info">
			<mat-icon>build</mat-icon>
		</button>
		<mat-menu class="linq-header-mat-menu linq-app-bar-menu" #buildInfoMenu="matMenu">
			<button mat-menu-item [clickToCopy]="buildInfoString" title="Copy to clipboard">
				<span>Build ID: {{ buildId }}</span>
			</button>
			<button mat-menu-item [clickToCopy]="buildInfoString" title="Copy to clipboard">
				<span>Build Date: {{ buildDate }}</span>
			</button>
			<button mat-menu-item [clickToCopy]="ddContext?.session_id" title="Copy to clipboard">
				<span>Session: {{ ddContext?.session_id }}</span>
			</button>
		</mat-menu>
		<button *ngIf="elementActive(layoutElements.SETTINGS)" (click)="onSettingsButtonClick()" mat-icon-button aria-label="System Settings"
			matTooltip="System Settings">
			<mat-icon>settings</mat-icon>
		</button>
		<button *ngIf="elementActive(layoutElements.PROFILE)" mat-icon-button aria-label="Profile" restoreFocus="true"
			[matMenuTriggerFor]="profileMenu">
			<mat-icon>person</mat-icon>
		</button>
		<mat-menu class="linq-header-mat-menu linq-app-bar-menu" #profileMenu="matMenu">
			<h4>Profile</h4>
			<div mat-menu-item disabled>
				<span>{{ fullName }}</span>
			</div>
			<div mat-menu-item disabled>
				<span>{{ email }}</span>
			</div>
			<button *ngIf="enableChangeUnit" (click)="changeUnit()" mat-menu-item>
				<span>Switch to Another Unit</span>
			</button>
			<button (click)="logout()" mat-menu-item>
				<span>Logout</span>
			</button>
		</mat-menu>
	</mat-toolbar>
</header>
